function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgImgPlaceholder = function SvgImgPlaceholder(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\u0421\u043B\u043E\u0439_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 156.503 166",
    style: {
      enableBackground: "new 0 0 156.503 166"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0080C9",
      fillOpacity: 0.12
    },
    d: "M108.355,158.283c-3.084,7.073-12.659,9.629-21.503,6.221l-74.083-38.601 c-6.572-3.493-12.09-9.969-12.415-16.871L0.03,22.799C-0.538,9.251,7.008-1.316,17.151,0.133l120.577,17.979 c15.904,2.215,23.126,18.576,16.066,34.766L108.355,158.283z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M18.045,86.025c0.243-2.812,0.73-5.113,1.379-6.987c0.649-1.96,1.623-3.579,2.678-4.857 c1.136-1.363,2.434-2.471,3.976-3.238c1.542-0.852,3.327-1.704,5.274-2.471c1.055-0.426,2.272-0.767,3.57-0.937 c1.298-0.17,2.516-0.426,3.733-0.767c1.136-0.341,2.191-0.937,3.165-1.875c0.893-0.852,1.542-2.215,1.866-4.175 c0.73-4.26-1.217-6.987-5.599-8.18c-2.029-0.597-3.895-0.597-5.599-0.085c-1.704,0.511-3.489,1.875-5.274,4.09l-5.112-10.907 c2.272-2.641,4.787-4.431,7.708-5.198c3.002-0.852,6.491-0.767,10.549,0.085c2.434,0.511,4.706,1.363,6.735,2.556 c2.028,1.193,3.732,2.812,5.112,4.772c1.298,1.96,2.191,4.26,2.678,6.902c0.487,2.641,0.406,5.539-0.243,8.691V63.7 c-0.649,3.323-1.785,5.88-3.408,7.754c-1.542,1.789-3.327,3.153-5.274,4.09c-1.947,0.937-3.895,1.619-5.923,2.13 c-1.947,0.511-3.814,1.023-5.599,1.619c-1.704,0.596-3.165,1.363-4.382,2.386c-1.217,1.022-2.028,2.471-2.434,4.346l20.691,8.691 l-1.785,8.862L17.721,90.456L18.045,86.025z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M94.395,109.287l-5.193,13.719l-12.496-5.709l4.382-13.463L55.447,93.523L57.8,82.957l38.056-29.653 l18.257,4.09L98.534,98.551l8.844,3.238l-4.463,10.907L94.395,109.287z M84.496,93.438l6.491-20.11L69.972,88.155L84.496,93.438z"
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgImgPlaceholder, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/img-placeholder.e4ae5da5.svg";
export { ForwardRef as ReactComponent };